import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Flex, Tooltip, Typography } from "antd";
import React from "react";
import { RenderProps } from "../DynamicColumn";

export default (props: RenderProps) => {
  const t = useTranslation();

  const hasAlarm =
    props.item.stockAlarmAt &&
    props.item.stock &&
    props.item.stockAlarmAt >= props.item.stock;

  return (
    <Flex gap="8px" align="center">
      <Typography.Text>{`${props.item.stock ?? ""} ${props.item.stockUnit ?? ""}`}</Typography.Text>
      {hasAlarm && (
        <Tooltip title={t("maintenance:item.table.label.stock_alarm")}>
          <Icon
            icon="fa:exclamation-triangle"
            color="var(--opendash-color-red)"
          />
        </Tooltip>
      )}
    </Flex>
  );
};
